// extracted by mini-css-extract-plugin
export default {"container":"styles_container__PfDut","content":"styles_content__2BvsZ","footer":"styles_footer__cxQxp","poweredBy":"styles_poweredBy__WZ1OO"};